import ProfileSettingsModal from "./common/ProfileSettingsModal.vue";

const LocationReloader = () => import('./common/LocationReloader.vue')
const SignupRoleSelectionPage = () => import('./signup/SignupRoleSelectionPage.vue')
const SignupUsernamePasswordPage = () => import('./signup/SignupUsernamePasswordPage.vue')
const SignupCreateClassPage = () => import('./signup/SignupCreateClassPage.vue')
const SignupCreateStudentsPage = () => import('./signup/SignupCreateStudentsPage.vue')
const SignupCompletePage = () => import('./signup/SignupCompletePage.vue')
const SignupUpdateInfoPage = () => import('./signup/SignupUpdateInfoPage.vue')
const SignupUpdateAgePage = () => import('./signup/SignupUpdateAgePage.vue')
const SignupSchoolInfoPage = () => import('./signup/SignupSchoolInfoPage.vue')
const SignupCreateClassroomPage = () => import('./signup/SignupCreateClassroomPage.vue')
const SignupClassHandout = () => import('./signup/SignupClassHandout.vue')
const ClassListPage = () => import('./teacher/ClassListPage.vue')
const ClassDetailPage = () => import('./teacher/ClassDetailPage.vue')
const ClassCreatePage = () => import('./teacher/ClassCreatePage.vue')
const StudentListPage = () => import('./teacher/StudentListPage.vue')
//const ActivityPage = () => import('./teacher/ActivityPage.vue')
const ActivityPage = () => import('./refactoring pages/pages/ActivityTeacher.vue')

const StudentDashboardPage = () => import('./student/StudentDashboardPage.vue')
const StudentTestPage = () => import('./student/StudentTestPage.vue')
const StudentQuizResultPage = () => import('./student/StudentQuizResultPage.vue')
const StudentQuizReviewPage = () => import('./student/StudentQuizReviewPage.vue')
const StudentProgressPage = () => import('./student/StudentProgressPage.vue')
const CoppaContractPage = () => import('./admin/CoppaContractPage.vue')
const SubscriptionHomePage = () => import('./teacher/SubscriptionHomePage.vue')
const SignupSubscriptionPricingPage = () => import('./teacher/SignupSubscriptionPricingPage.vue')
const ContactPage = () => import('./common/ContactPage.vue')
const TeacherProgressReportPage = () => import('./teacher/TeacherProgressReportPage.vue')
const StudentSummaryReport = () => import('./teacher/StudentSummaryReport.vue')
const TeacherMonthlyReportPage = () => import('./teacher/TeacherMonthlyReportPage.vue')
const SalesQuotePage = () => import('./quote/SalesQuotePage.vue')
const StripeBillingPage = () => import('./common/setting/StripeBillingPage.vue')

export const routes = [
  { path: '/app/sign-up/role', component: SignupRoleSelectionPage, name: 'role-select' },
  // { path: '/register', component: SignupRoleSelectionPage, name: 'role-select'},
  { path: '/app/sign-up/create-account/:role', component: SignupUsernamePasswordPage, name: 'create-account' },
  { path: '/app/sign-up/more-info', component: SignupUpdateInfoPage, name: 'update-info' },
  { path: '/app/sign-up/school-info', component: SignupSchoolInfoPage, name: 'school-info' },
  { path: '/app/sign-up/student-info', component: SignupUpdateAgePage, name: 'student-info' },
  { path: '/app/sign-up/create-classroom', component: SignupCreateClassroomPage, name: 'create-classroom' },
  { path: '/app/sign-up/pricing', component: SignupSubscriptionPricingPage, name: 'signup-pricing' },
  { path: '/app/sign-up/create-class', component: SignupCreateClassPage, name: 'create-class' },
  { path: '/app/pricing/:role', component: SubscriptionHomePage, name: 'checkout-subscription-role' },
  { path: '/app/pricing', component: SubscriptionHomePage, name: 'checkout-subscription' },
  { path: '/app/contact', component: ContactPage, name: 'contact' },
  { path: '/app/sales/school-quote-request', component: SalesQuotePage, name: 'school-quote-request' },
  // { path: '/app/class/create', component: SignupCreateClassPage, name: 'class-create' },

  { path: '/app/sign-up/create-students/:tabIndex?', component: SignupCreateStudentsPage, name: 'add-students' },
  { path: '/app/sign-up/summary', component: SignupCompletePage, name: 'summary' },
  { path: '/app/class/:classCode/handout', component: SignupClassHandout, name: 'class-handout' },
  { path: '/app/demo', component: StudentTestPage, name: 'welcome-pretest' },
  // { path: '*', redirect: '/welcome/userHome' }
  { path: '/app/studentSummaryReport', component: StudentSummaryReport, name: 'student-summary-report', props: { customReport: true } },

  //teacher
  { path: '/app/teacher/class/list', component: ClassListPage, name: 'class-list' },
  { path: '/app/teacher/class/create', component: ClassCreatePage, name: 'class-create' },
  { path: '/app/teacher/class/:id', component: ClassDetailPage, name: 'class-detail' },
  { path: '/app/teacher/student/list', component: StudentListPage, name: 'students' },
  { path: '/app/teacher/activities', component: ActivityPage, name: 'activities' },
  { path: '/app/teacher/reports/class/:classid', component: TeacherProgressReportPage, name: 'class-reports', props: { customReport: true } },
  { path: '/app/teacher/reports/student/:studentid', component: TeacherProgressReportPage, name: 'student-reports', props: { customReport: true } },
  { path: '/app/teacher/reports*', component: TeacherProgressReportPage, name: 'reports', props: { customReport: true } },
  { path: '/app/teacher/monthlyReport/class/:classid', component: TeacherMonthlyReportPage, name: 'monthly-class-report' },
  { path: '/app/teacher/monthlyReport', component: TeacherMonthlyReportPage, name: 'monthly-report' },

  //student
  { path: '/app/student/dashboard', component: StudentDashboardPage, name: 'student-dashboard' },
  { path: '/app/student/quiz', component: StudentTestPage, name: 'student-quiz' },
  { path: '/app/student/quiz-cache', component: StudentTestPage, name: 'student-quiz-cache' },
  { path: '/app/student/pretest', component: StudentTestPage, name: 'pretest-quiz' },
  { path: '/app/student/quiz/results', component: StudentQuizResultPage, name: 'quiz-results' },
  { path: '/app/student/quiz/review', component: StudentQuizReviewPage, name: 'quiz-review' },
  { path: '/app/student/report/:tabNum', component: StudentProgressPage, name: 'student-report', props: { customReport: true } },
  { path: '/app/student/report', component: StudentProgressPage, name: 'student-report', props: { customReport: true } },
  //admin
  // correct coppa path: /admin/app/coppa/list
  { path: '/app/admin/coppa/list', component: CoppaContractPage, name: 'coppa-contracts' },
  { path: '/app/student/quiz/ended', component: LocationReloader, name: 'quiz-ended', props: { goto: '/app/student/quiz' } },
  { path: '/app/user/billing', component: StripeBillingPage, name: 'billing-portal' }
];

